import type { ToneOverlay } from "../index.js";

// "Oma"-Stimme auf Deutsch: warmherzig, aber praktisch — Essen, Tee und "zieh dir was an".
// Wie "dark" eine Stimme zum Auflockern, daher rotieren die Zeilen alle zwei Stunden
// (TONE_ROTATE_MS). Jede Variante behält die {Platzhalter} des Basistexts.
export const overlay: ToneOverlay = {
  "alert.toast.new": [
    "{hazard} in deiner Nähe, Kindchen — pass jetzt auf",
    "{hazard} ganz nah, mein Junge. Augen auf.",
    "{hazard} in der Nähe — das gefällt mir nicht. Vorsicht.",
    "{hazard} nah dran. Sei vorsichtig, hörst du?",
    "{hazard} hier in der Nähe. Bleib bei mir, ja?",
  ],
  "alert.toast.escalation": [
    "Der {hazard} wird schlimmer, warte nicht, hör auf die Oma",
    "Der {hazard} wächst, Kindchen — beweg dich jetzt",
    "{hazard} jetzt schlimmer. Sei nicht stur, geh.",
    "{hazard} breitet sich aus. Um Himmels willen. Beeil dich.",
  ],
  "alert.toast.inPath": [
    "Der {hazard} kommt auf dich zu — beweg dich, mein Junge",
    "{hazard} kommt zu dir, Kindchen — geh, geh",
    "{hazard} kommt hinter dir her. Auf, auf, beweg dich!",
    "{hazard} fast an deiner Tür — geh jetzt, um Himmels willen",
  ],
  "alert.toast.allClear": [
    "Alles ruhig bei {place}, Gott sei Dank",
    "{place} ist wieder ruhig. Setz dich, atme.",
    "Sicher bei {place}, Kindchen. Ich hatte solche Angst.",
    "Alles gut bei {place}. Jetzt trink einen Tee.",
  ],
  "alert.toast.tap": [
    "Komm her, tipp hier — die Oma sagt dir, was zu tun ist",
    "Tipp, Kindchen — ich erklär's dir",
    "Tipp hier. Die Oma hat einen Plan.",
  ],
  "alert.takeover.title": [
    "{hazard} — los, beweg dich, und keine Widerrede",
    "{hazard} — auf, auf! Geh, ich mein's ernst",
    "{hazard} — Schluss mit Reden, beweg dich, mein Junge",
  ],
  "alert.takeover.details": "Zeig mir alles",
  "alert.takeover.dismiss": "Ja, ja, ist gut",
  "now.status.allClear": [
    "Alles ruhig, mein Junge.",
    "Jetzt still, Kindchen.",
    "Alles gut — setz dich, ruh dich aus.",
    "Alles gut. Hast du schon gegessen?",
    "Ruhig, Gott sei Dank.",
    "Schön ruhig. Ruh dich ein bisschen aus.",
    "Jetzt friedlich. Und zieh dir was an.",
  ],
  "now.status.stayAware": [
    "Bleib wachsam, hörst du?",
    "Augen auf, Kindchen.",
    "Pass auf, tu's der Oma zuliebe.",
    "Vorsicht, ja?",
    "Bleib in der Nähe, mein Junge.",
  ],
  "now.status.sub.allClear": [
    "Gerade nichts in der Nähe. Trink etwas Wasser.",
    "Alles ruhig. Hast du etwas gegessen?",
    "Nichts in deinem Radius. Setz dich kurz hin.",
    "Vorerst sauber, Kindchen. Atme.",
    "Nichts in der Nähe. Zieh trotzdem eine Jacke an.",
  ],
  "now.activity.empty": [
    "Gerade ruhig. Hast du gegessen?",
    "Nichts los. Ruh dich ein bisschen aus.",
    "Alles ruhig. Ruf deine Mutter an, hörst du?",
    "Nichts hier, Kindchen. Iss was Warmes.",
    "Leer und still. Genieß es, mein Junge.",
  ],
  "onboarding.promise.tagline": "Nachbarn, die füreinander da sind, wie Familie.",
  "onboarding.promise.continue": "Komm rein, komm rein",
  "onboarding.home.browse": "Nur mal schauen, vorerst",
  "you.voice.intro": "Sag mir, wie ich mit dir reden soll, mein Junge.",
};
